import request from '@/utils/request'

export function customerList(data) {
  return request({
    url: '/group_master/customer',
    method: 'post',
    data
  })
}

export function customerUpdate(id, data) {
  return request({
    url: '/group_master/customer/' + id,
    method: 'post',
    data
  })
}

export function customerRedpack(id, data) {
  return request({
    url: '/group_master/customer/' + id + '/newbee',
    method: 'post',
    data
  })
}


export function fcSave(code) {
  return request({
    url: '/group_master/friendcode',
    method: 'post', 
    data: {
      code
    }
  })
}

export function fcAuth() {
  return request({
    url: '/group_master/upload_auth',
    method: 'post'
  })
}
